import axios from "axios";
import { pp } from "@/lib/portalHost";

const papi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/client` });
export const PTOKEN = "omnibat_client_token";
papi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(PTOKEN);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
papi.interceptors.response.use((r) => r, (e) => {
  if (e.response?.status === 401 && localStorage.getItem(PTOKEN)) {
    localStorage.removeItem(PTOKEN);
    window.location.href = pp("/login");
  }
  return Promise.reject(e);
});
export const perr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return "Une erreur est survenue. Réessayez.";
};
export const money = (n) => `${Math.round(n || 0).toLocaleString("fr-FR")} FCFA`;
export const dfr = (s) => (s ? new Date(s.length <= 10 ? `${s}T00:00:00` : s).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : "—");
export const openBlob = async (url) => {
  const w = window.open("", "_blank");
  try { const r = await papi.get(url.replace(/^\/client/, ""), { responseType: "blob" }); const u = URL.createObjectURL(r.data); if (w) w.location.href = u; else window.location.href = u; }
  catch (e) { if (w) w.close(); throw e; }
};
export default papi;
